export default __webpack_public_path__ + "static/media/followers.b81e381b.png";